import { Container } from 'react-grid-system';
import styled from 'styled-components';

const DivPadded = styled.div`
  padding: 32px;
`;

const Main = styled.div`
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
`;

const Nav = styled.div`
  width: 100%;
  top: 0;
`;

const Body = styled.div`
  display: flex;
  margin: 0;
  min-height: calc(100vh - 60px);
`;

const DivSideMenu = styled(Container)`
  min-width: ${({ open, $showSideNav }) =>
    open || !$showSideNav ? '100vw' : 'calc(100vw - 60px)'};
  width: 100%;
  transition: 0.1s ease-in-out;
  width: auto;
  max-height: calc(100vh - 60px);
  overflow-x: auto;
  overflow-y: ${({ $showSideNav }) => ($showSideNav ? 'auto' : 'scroll')};
  margin: 0 !important;
  padding: 0 !important;
`;

const OverLay = styled.div`
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;
  cursor: pointer;
`;

const LoaderContainer = styled.div`
  height: 100%;
  width: 100%;
`;

const MainLayoutStyle = {
  DivPadded,
  Main,
  Nav,
  Body,
  DivSideMenu,
  OverLay,
  LoaderContainer,
};

export default MainLayoutStyle;
